import { render, staticRenderFns } from "./QuickResponseListElement.vue?vue&type=template&id=9f1a7120&"
import script from "./quick-response-list-element.ts?vue&type=script&lang=ts&"
export * from "./quick-response-list-element.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports